export default __webpack_public_path__ + "static/media/gallery - original vs translated_04.661dadd3.jpg";